/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RelocateScreenerResidentRequest
 */
export interface RelocateScreenerResidentRequest {
    /**
     * 
     * @type {string}
     * @memberof RelocateScreenerResidentRequest
     */
    bed_id: string;
    /**
     * 
     * @type {string}
     * @memberof RelocateScreenerResidentRequest
     */
    bed_change_date: string;
}

/**
 * Check if a given object implements the RelocateScreenerResidentRequest interface.
 */
export function instanceOfRelocateScreenerResidentRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "bed_id" in value;
    isInstance = isInstance && "bed_change_date" in value;

    return isInstance;
}

export function RelocateScreenerResidentRequestFromJSON(json: any): RelocateScreenerResidentRequest {
    return RelocateScreenerResidentRequestFromJSONTyped(json, false);
}

export function RelocateScreenerResidentRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): RelocateScreenerResidentRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'bed_id': json['bed_id'],
        'bed_change_date': json['bed_change_date'],
    };
}

export function RelocateScreenerResidentRequestToJSON(value?: RelocateScreenerResidentRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'bed_id': value.bed_id,
        'bed_change_date': value.bed_change_date,
    };
}

